/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Subtitle_ShortInputs */

const en_us2_coach_subtitle_short = /** @type {(inputs: Coach_Subtitle_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Based on studies`)
};

const pt_br2_coach_subtitle_short = /** @type {(inputs: Coach_Subtitle_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com base em estudos`)
};

const es_419_coach_subtitle_short = /** @type {(inputs: Coach_Subtitle_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basado en estudios`)
};

const pt_pt2_coach_subtitle_short = /** @type {(inputs: Coach_Subtitle_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com base em estudos`)
};

const fr_fr2_coach_subtitle_short = /** @type {(inputs: Coach_Subtitle_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fondé sur des études`)
};

const de_de2_coach_subtitle_short = /** @type {(inputs: Coach_Subtitle_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf Basis von Studien`)
};

const it_it2_coach_subtitle_short = /** @type {(inputs: Coach_Subtitle_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basato su studi`)
};

/**
* | output |
* | --- |
* | "Based on studies" |
*
* @param {Coach_Subtitle_ShortInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_subtitle_short = /** @type {((inputs?: Coach_Subtitle_ShortInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Subtitle_ShortInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_subtitle_short(inputs)
	if (locale === "es-419") return es_419_coach_subtitle_short(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_subtitle_short(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_subtitle_short(inputs)
	if (locale === "de-DE") return de_de2_coach_subtitle_short(inputs)
	if (locale === "it-IT") return it_it2_coach_subtitle_short(inputs)
	return en_us2_coach_subtitle_short(inputs)
});
export { coach_subtitle_short as "coach.subtitle_short" }